/* global swal, moment */
import employeeModalTemplate from 'modals/employeesSearch/index.html';
import employeeModalController from 'modals/employeesSearch';
import {
  controller as registerController,
  controllerAs as registerControllerAs,
  template as registerTemplate
} from 'modals/marketplaceRegister';

import { clone } from 'lodash';

export default function(
  $log,
  $uibModal,
  $sce,
  $state,
  $window,
  ProfileClass,
  EventClass,
  CoursesClass,
  ApiClass,
  $uibModalStack,
  $location,
  AuthClass,
  Swal,
  UserClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const openRegistrationModal = (eventOrCourseParam, user) => {
    getCourseOrEvent(eventOrCourseParam)
      .then(eventOrCourse => {
        vm.eventOrCourse = eventOrCourse;
        $uibModal
          .open({
            backdrop: true,
            size: 'lg',
            template: registerTemplate,
            controller: registerController,
            controllerAs: registerControllerAs,
            resolve: {
              event: () => vm.eventOrCourse,
              bundle: () => false,
              adminRegistration: () => vm.adminRegistration,
              profileData: () => user,
              manage: () => true,
              loadContent: () => false
            }
          })
          .result.then(status => {
            if (CoursesClass.isCourse(eventOrCourse)) {
              switch (status) {
                case 'registered':
                case 'userRegistered':
                  Swal.toast('User registration successful!');
                  if (vm.successCallback)
                    return vm.successCallback({ response: status, params: vm.successCallbackParams });
                  vm.loading = true;
                  // TODO: Timeout is here to wait for API to process. Need to get the status returned in the call.
                  setTimeout(() => $state.go('app.courses.course', { id: eventOrCourse.course_id }), 3000);
                  break;
                case 'userAlreadyRegistered':
                  Swal.toast('User already registered!', 'info');
                  if (vm.successCallback)
                    return vm.successCallback({ response: status, params: vm.successCallbackParams });
                  break;
                case 'userNotRegistered':
                  Swal.toast('User registration failed!', 'error');
                  break;
                case 'passRedemptionFailure':
                  Swal.toast('Pass could not be redeemed for this course or user', 'error');
                  break;
                case 'creditCardFailure':
                  Swal.toast('User registration failed. Credit card was not processed.', 'error');
                  break;
              }
            }

            if (EventClass.isEvent(eventOrCourse)) {
              switch (status) {
                case 'registered':
                case 'userRegistered':
                  Swal.toast('User registration successful!');
                  if (vm.successCallback)
                    return vm.successCallback({ response: status, params: vm.successCallbackParams });
                  vm.loading = true;
                  // TODO: Timeout is here to wait for API to process. Need to get the status returned in the call.
                  setTimeout(() => $state.go('app.events.event', { id: eventOrCourse.event_id }), 3000);
                  break;
                case 'userAlreadyRegistered':
                  if (vm.successCallback)
                    return vm.successCallback({ response: status, params: vm.successCallbackParams });
                  Swal.toast('User already registered!', 'info');
                  break;
                case 'userNotRegistered':
                  Swal.toast('User registration failed!', 'error');
                  break;
                case 'passRedemptionFailure':
                  Swal.toast('Pass could not be redeemed for this course or user', 'error');
                  break;
                case 'creditCardFailure':
                  Swal.toast('User registration failed. Credit card was not processed.', 'error');
                  break;
                case 'full':
                  const swalText =
                    'This course is currently full and does not have a waitlist available.Please check again to see if a spot is available or contact the event organizer for assistance.';
                  Swal.alert('', swalText, 'warning').then(() =>
                    $state.go('app.events.event', { id: eventOrCourse.event_id })
                  );
                  vm.full = true;
                  break;
                default:
                  eventOrCourse.status = status;
                  Swal.toast(`You have been ${status} for the event.`);
              }
            }

            if (eventOrCourse.type === 'scorm' && eventOrCourse.course_id !== 'scorm' && !eventOrCourse.event_id) {
              vm.loading = true;
              setTimeout(
                () => $state.go('app.courses.course', { id: eventOrCourse.course_id }, { reload: true }),
                3000
              );
            }

            vm.registrationCallback();
          })
          .catch(error => {
            if (error === 'cancel' || error === 'backdrop click') return;
            $log.error(error);
          });
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: error.status, refresh: activate };
        throw error;
      });
  };

  const registerProfileUid = () => {
    ApiClass.usersIdGet({ id: vm.profileUid, manage: true })
      .then(({ data: { item: profile } }) => {
        openRegistrationModal(vm.eventOrCourse, profile);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  const selectEmployees = () => {
    const selectModalInstance = $uibModal.open({
      backdrop: 'static',
      animation: true,
      size: 'lg',
      template: employeeModalTemplate,
      controller: employeeModalController(undefined, undefined, true),
      controllerAs: 'employeeModalCtrl'
    });

    selectModalInstance.result
      .then(users => {
        if (users.length > 0) {
          openRegistrationModal(vm.eventOrCourse, users[0]);
        }
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.register = () => {
    if (vm.profileUid) return registerProfileUid();
    selectEmployees();
  };

  function getCourseOrEvent(eventOrCourse) {
    if (eventOrCourse != null) {
      return Promise.resolve(eventOrCourse);
    }

    if (vm.eventId) {
      return ApiClass.eventsIdGet({ id: vm.eventId }).then(({ data: { event } }) => {
        vm.selectedEvent = vm.deliveryLocation || event.delivery_location;
        return event;
      });
    }

    if (vm.courseId) {
      return ApiClass.coursesIdGet(
        { id: vm.courseId },
        {},
        { queryParams: { 'joins:passes': true, manage: true } }
      ).then(({ data: { course } }) => {
        return course;
      });
    }

    return Promise.resolve(vm.eventOrCourse);
  }

  function activate() {
    vm.isAdminOrTeamLeader = UserClass.admin || UserClass.team_leader;
    vm.eventOrCourse = clone(vm.eventOrCourse);

    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/marketplaceAdminReg/controller.js